import React from 'react';
import { ConfidencePill, Accordion, PrimaryButton } from '../../shared';
import './PickCardV2.css';

const formatGameTime = (gameTime, date) => {
  if (!gameTime || gameTime === 'TBD') return 'Time TBD';
  try {
    let d;
    if (gameTime.includes(' ') || gameTime.includes('T')) {
      d = new Date(gameTime.replace(' ', 'T'));
    } else {
      const dateStr = date || new Date().toISOString().split('T')[0];
      d = new Date(`${dateStr}T${gameTime}:00`);
    }
    if (isNaN(d.getTime())) return gameTime;
    return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }) + ' • ' +
           d.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' });
  } catch { return gameTime; }
};

const PickCardV2 = ({ pick, onAdd }) => {
  const {
    matchup, selection, odds, confidence, game_time, date, result,
    win_probability, market_stability, book_count,
    ev, reasoning, analysis
  } = pick;

  const isSettled = result && result !== 'pending';

  return (
    <div className={`pick-card-v2${isSettled ? ` settled ${result}` : ''}`}>
      <div className="pick-header">
        <span className="pick-time">{formatGameTime(game_time, date)}</span>
        {isSettled ? (
          <span className={`result-badge ${result}`}>{result.toUpperCase()}</span>
        ) : (
          <ConfidencePill level={confidence} />
        )}
      </div>
      
      <h3 className="pick-matchup">{matchup}</h3>
      <div className="pick-selection">{selection} <span className="pick-odds">({odds > 0 ? '+' : ''}{odds})</span></div>
      
      <div className="pick-metrics">
        {win_probability && (
          <div className="metric">
            <span className="metric-label">Model Prob</span>
            <span className="metric-value">{win_probability}%</span>
          </div>
        )}
        {market_stability && (
          <div className="metric">
            <span className="metric-label">Stability</span>
            <span className="metric-value">{market_stability}</span>
          </div>
        )}
        {book_count && (
          <div className="metric">
            <span className="metric-label">Consensus</span>
            <span className="metric-value">{book_count}-book</span>
          </div>
        )}
      </div>
      
      <Accordion title="Details">
        {ev !== undefined && (
          <div className="detail-row">
            <span>Expected Value:</span>
            <span className={ev >= 0 ? 'positive' : 'negative'}>{ev > 0 ? '+' : ''}{ev}%</span>
          </div>
        )}
        {reasoning && <p className="detail-text">{reasoning}</p>}
        {analysis && <p className="detail-text">{analysis}</p>}
      </Accordion>
      
      <PrimaryButton onClick={() => onAdd(pick)} className="add-pick-btn" disabled={isSettled}>
        {isSettled ? 'Game Ended' : 'Add to Bet Slip'}
      </PrimaryButton>
    </div>
  );
};

export default PickCardV2;
